"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressViewWidget = void 0;
var React = require("react");
var moment = require("moment");
var journey_services_1 = require("@athena-portal/journey-services");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../commonFunctions");
var services_1 = require("@falcon/services");
var AddressViewWidget = /** @class */ (function (_super) {
    __extends(AddressViewWidget, _super);
    function AddressViewWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.navigateToChangeAddress = function () {
            var changeAddressJourneyLink = function (process) {
                switch (process) {
                    case services_1.INTERACTION_PROCESS_MTA.toString():
                        return "/journey/show/product/AnnualHomeInsurance/process/mtaChangeAddress/preset/".concat(_this.props.interaction._id);
                    case services_1.INTERACTION_PROCESS_RENEWAL.toString():
                        return "/journey/show/product/AnnualHomeInsurance/process/renewal/propertyDetails/".concat(_this.props.interaction._id);
                    default:
                        return "/journey/show/product/AnnualHomeInsurance/process/mtaSupportPortalAnnualHomeChangeAddress/preset/".concat(_this.props.interaction._id);
                }
            };
            window.location.assign(changeAddressJourneyLink(_this.props.interaction.process));
        };
        return _this;
    }
    AddressViewWidget.prototype.render = function () {
        if (!this.props.question.interactionField)
            return React.createElement(React.Fragment, null);
        var interaction = this.props.interaction;
        var uistate = interaction.uistate;
        var allowAddressChange = uistate.minMtaStartDate ? moment(uistate.maxMtaStartDate) >= moment(uistate.minMtaStartDate) : true;
        var address = journey_services_1.ObjectManipulator.fetchFieldValue(this.props.question.interactionField, this.props.interaction);
        var fullAddress = (0, commonFunctions_1.getAddressLines)(address)
            .map(function (line, index) {
            return React.createElement("div", { id: "address-line-" + index }, line);
        });
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "property-details form-group home-address-lookup" },
                React.createElement("label", { htmlFor: "address-display" }, this.props.question.label),
                React.createElement("div", { className: "input-group" },
                    React.createElement("div", { className: "address-display", id: "address-display" },
                        fullAddress,
                        React.createElement("button", { className: allowAddressChange ? "btn btn-text btn-panel-edit" : "btn btn-disabled btn-text btn-panel-edit", role: "link", onClick: this.navigateToChangeAddress }, "Change address")))));
    };
    return AddressViewWidget;
}(plugin_journey_1.WidgetBase));
exports.AddressViewWidget = AddressViewWidget;
//# sourceMappingURL=AddressViewWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/AddressViewWidget.js
// module id = 3494
// module chunks = 0